if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  const mediaEls = document.querySelectorAll('.mormaii-lifestyle-mosaic__media');

  if (mediaEls.length) {
    const maxZoom = 1.1;
    const settleAt = 75; // percent of the element's scroll transit where it reaches normal size
    const visible = new Set();

    const percentageSeen = (element) => {
      const viewportHeight = window.innerHeight;
      const scrollY = window.scrollY;
      const elementPositionY = element.getBoundingClientRect().top + scrollY;
      const elementHeight = element.offsetHeight;

      if (elementPositionY > scrollY + viewportHeight) return 0;
      if (elementPositionY + elementHeight < scrollY) return 100;

      const distance = scrollY + viewportHeight - elementPositionY;
      return distance / ((viewportHeight + elementHeight) / 100);
    };

    const updateZoom = (media) => {
      const percent = Math.min(percentageSeen(media), settleAt);
      const ratio = maxZoom - (maxZoom - 1) * (percent / settleAt);
      media.style.setProperty('--mormaii-mosaic-zoom', ratio.toFixed(3));
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          visible.add(entry.target);
          updateZoom(entry.target);
        } else {
          visible.delete(entry.target);
        }
      });
    });

    mediaEls.forEach((media) => observer.observe(media));

    window.addEventListener(
      'scroll',
      throttle(() => {
        visible.forEach((media) => updateZoom(media));
      }),
      { passive: true }
    );
  }
}
